module.exports = __webpack_public_path__ + "img/guandai_yj_yangshuangshuang.4b250640.jpg";